import Svg, { Path } from 'react-native-svg'
export const InfoIco = () => (
  <Svg width={32} height={32} viewBox='0 0 32 32' fill='none'>
    <Path
      d='M15.9998 21.3332V15.9998M15.9998 10.6665H16.0132M29.3332 15.9998C29.3332 23.3636 23.3636 29.3332 15.9998 29.3332C8.63604 29.3332 2.6665 23.3636 2.6665 15.9998C2.6665 8.63604 8.63604 2.6665 15.9998 2.6665C23.3636 2.6665 29.3332 8.63604 29.3332 15.9998Z'
      stroke='#859CAD'
      strokeWidth={3}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </Svg>
)
